import styled from 'styled-components';
import { ChipLabelMixin } from '../../mixins/components/ChipLabelMixin';
export var StyledChipLabel = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledChipLabel",
  componentId: "c11n-8-111-1__sc-jj6k8p-0"
})(["", ""], ChipLabelMixin);